import { memo, useEffect } from 'react';
import { ContactForm } from './ContactForm';

/**
 * GetInTouchModal — the "Get in Touch" pop-up form from the design key,
 * triggered by the header and hero buttons. Closes on backdrop click or Esc.
 */
export const GetInTouchModal = memo(({ open, onClose, name, firstName, onSubmit }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = e => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="cw-modal" role="dialog" aria-modal="true" aria-label="Get in Touch" onClick={onClose}>
      <div className="cw-modal-card" onClick={e => e.stopPropagation()}>
        <button type="button" className="cw-modal-close" aria-label="Close" onClick={onClose}>
          ×
        </button>
        <ContactForm name={name} firstName={firstName} onSubmit={onSubmit} idPrefix="cf360-modal" />
      </div>
    </div>
  );
});
